import {cn} from '../../lib/utils';

import type {ComponentProps, ReactNode} from 'react';

export interface PageLayoutProps extends ComponentProps<'main'> {
  errorFallback?: ReactNode;
}

export function PageLayout({className, errorFallback, children, ...props}: PageLayoutProps) {
  return (
    <main
      data-slot="page-layout"
      className={cn('flex flex-col flex-1 min-h-0', className)}
      {...props}
    >
      {errorFallback ?? children}
    </main>
  );
}

export function PageContent({className, ...props}: ComponentProps<'div'>) {
  return (
    <div
      data-slot="page-content"
      className={cn('flex-1 min-h-0 overflow-auto pt-8 pb-8 px-page', className)}
      {...props}
    />
  );
}
